module.exports = __webpack_public_path__ + "static/media/YF48_3.6a1606a7.jpg";